import { Fragment, PropsWithChildren } from 'react'
import MenuImage from './menu-image'
import { ImageAd } from '@/lib/api/navigation/navigation.types'

interface NavigationFooterProps extends PropsWithChildren {
  imageAds: ImageAd[]
}

const NavigationFooter = ({ imageAds, children }: NavigationFooterProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-11 sm:flex-row md:h-full md:flex-row-reverse md:items-start md:justify-between md:gap-0 md:py-0">
      {imageAds &&
        imageAds.length &&
        imageAds.map((image, index) => {
          return (
            <Fragment key={`f0${image.url + index}`}>
              <MenuImage
                url={image.url}
                title={image.title}
                description={image.description}
              />

              {index === 0 && children}
            </Fragment>
          )
        })}
    </div>
  )
}

export default NavigationFooter
